import { useLocation } from 'react-router-dom';
export function useQueryParam(param) {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    return params.get(param);
}
